export default __webpack_public_path__ + "static/media/paneer.77e267d8.png";